import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE = '/creators/{creatorId}/product-list';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getProductsByCreatorId = async ({ creatorId, page, perPage, search }: Input): Promise<Output> => {
  const data = await noodleApiClient.get(`/creators/${creatorId}/product-list`, { params: { page, perPage, search } });
  return data.data;
};

export default getProductsByCreatorId;
